// styling for this component is in emiCardPayment.scss

import { initPayment } from '@/redux/actions';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import { getDeviceInfo } from '@/utils/deviceInfo';
import { PAYMENT_TYPE_CONSTANTS } from '@/utils/constants';
import { BackArrow } from '@/assets/svgExports/BackArrow';

const rangeOfYears = () => {
  const result = [];
  let min = new Date().getUTCFullYear();
  const max = min + 20;
  while (min <= max) {
    result.push('' + min);
    min++;
  }
  return result;
};

const EmiCardPayment = ({ isDesktop = true }) => {
  const dispatch = useDispatch();
  const router = useRouter();

  const [emiInformation] = useState({
    cardInformation: {
      cardNumber: '',
      monthSelected: '01',
      yearSelected: rangeOfYears()[0],
      cvv: '',
    },
    cvvLength: 3,
    selectedEmi: {},
    step: 1,
    completedSteps: [],
    cardType: '',
    emiAvailable: true,
  });

  const { userData, orderDetails, store } = useSelector((state) => ({
    store: state.storeReducer.store,
    orderDetails: state.orderReducer.orderDetails,
    userData: state.userReducer,
  }));

  const validateAll = () => {
    return true;
  };

  const completeEmiPaymentInit = () => {
    if (validateAll()) {
      const data = {
        orderID: orderDetails?.order_hash,
        paymentMethod: PAYMENT_TYPE_CONSTANTS.EMI,
        merchantID: orderDetails?.merchant_id,
        deviceType: getDeviceInfo().OSName,
        browserType: getDeviceInfo().BrowserName,
        userAgent: getDeviceInfo().userAgent,
        source: 'longtail',
        merchantName: `Digital Showroom - ${store?.store_info?.name}`,
        emiCode: emiInformation.selectedEmi.emi_code,
        phone: userData?.data?.phone,
      };
      dispatch(initPayment(data, router));
    }
  };

  return (
    <div className="emiCardPayment">
      {!isDesktop && (
        <div className="page-header flex items-center">
          <BackArrow onClick={() => router.back()} />
          <span className="header-text ml3 fw6">EMI</span>
        </div>
      )}
      <button
        onClick={completeEmiPaymentInit}
        className="tw-w-full tw-cursor-pointer !tw-rounded-[12px] tw-bg-black tw-p-3 tw-font-inter tw-text-lg tw-text-white"
      >
        Continue
      </button>
    </div>
  );
};

export default EmiCardPayment;
